import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-modal-footer",
    styleUrl: "modal-footer.scss",
    shadow: false
})
export class ModalFooter {
    render() {
        return (
            <Host class="ux-modal-footer">
                <slot />
            </Host>
        );
    }
}
